export const UZASBO_STATUSES = {
  DRAFT: 100,
  SENT_TO_ORG_HEAD: 200,
  REJECTED_BY_ORG_HEAD: 300,
  APPROVED_BY_ORG_HEAD: 400,
  REJECTED_BY_INNOVATION: 500,
  APPROVED_BY_INNOVATION: 600,
  SENT_TO_UZASBO: 700,
}

export const UZASBO_BATCH_STATUSES = {
  FORMING: 100,
  APPROVED: 200,
  SENT_TO_UZASBO: 300,
}

export const getUzAsboStatus = status => ({
  [UZASBO_STATUSES.DRAFT]: {
    name: { uz: 'Qoralama', ru: 'Черновик', en: 'Draft' },
    variant: 'secondary',
  },
  [UZASBO_STATUSES.SENT_TO_ORG_HEAD]: {
    name: {
      uz: "Ma'sul rahbarda",
      ru: 'У ответственного руководителя',
      en: 'With responsible head',
    },
    variant: 'warning',
  },
  [UZASBO_STATUSES.REJECTED_BY_ORG_HEAD]: {
    name: {
      uz: "Ma'sul rahbar rad etgan",
      ru: 'Отклонено руководителем',
      en: 'Rejected by head',
    },
    variant: 'danger',
  },
  [UZASBO_STATUSES.APPROVED_BY_ORG_HEAD]: {
    name: {
      uz: 'Innovatsiyada',
      ru: 'В Инновациях',
      en: 'With Innovation',
    },
    variant: 'info',
  },
  [UZASBO_STATUSES.REJECTED_BY_INNOVATION]: {
    name: {
      uz: 'Innovatsiya rad etgan',
      ru: 'Отклонено Инновациями',
      en: 'Rejected by Innovation',
    },
    variant: 'danger',
  },
  [UZASBO_STATUSES.APPROVED_BY_INNOVATION]: {
    name: {
      uz: 'Tasdiqlangan',
      ru: 'Утверждено',
      en: 'Approved',
    },
    variant: 'success',
  },
  [UZASBO_STATUSES.SENT_TO_UZASBO]: {
    name: {
      uz: 'UzAsbo ga yuborilgan',
      ru: 'Отправлено в UzAsbo',
      en: 'Sent to UzAsbo',
    },
    variant: 'primary',
  },
}[status] || {
  name: { uz: '-', ru: '-', en: '-' },
  variant: 'secondary',
})

export const MONTHS = [
  { id: 1, name: { uz: 'Yanvar', ru: 'Январь', en: 'January' } },
  { id: 2, name: { uz: 'Fevral', ru: 'Февраль', en: 'February' } },
  { id: 3, name: { uz: 'Mart', ru: 'Март', en: 'March' } },
  { id: 4, name: { uz: 'Aprel', ru: 'Апрель', en: 'April' } },
  { id: 5, name: { uz: 'May', ru: 'Май', en: 'May' } },
  { id: 6, name: { uz: 'Iyun', ru: 'Июнь', en: 'June' } },
  { id: 7, name: { uz: 'Iyul', ru: 'Июль', en: 'July' } },
  { id: 8, name: { uz: 'Avgust', ru: 'Август', en: 'August' } },
  { id: 9, name: { uz: 'Sentabr', ru: 'Сентябрь', en: 'September' } },
  { id: 10, name: { uz: 'Oktabr', ru: 'Октябрь', en: 'October' } },
  { id: 11, name: { uz: 'Noyabr', ru: 'Ноябрь', en: 'November' } },
  { id: 12, name: { uz: 'Dekabr', ru: 'Декабрь', en: 'December' } },
]

export const getMonthName = month => (MONTHS.find(item => item.id === month) || {}).name

export const yearOptions = () => {
  const current = new Date().getFullYear()
  return [current + 1, current, current - 1, current - 2]
}

export default function config() {
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'period', label: 'Period' },
    { key: 'organization_name', label: 'Organization', sortable: false },
    { key: 'items_count', label: 'Researchers count' },
    { key: 'status', label: 'Status' },
    { key: 'org_head_comment', label: 'Comment' },
    { key: 'created_at', label: 'Created At' },
    { key: 'actions', label: 'Actions' },
  ]

  const itemColumns = [
    { key: 'index', label: '#' },
    { key: 'pnfl', label: 'PNFL' },
    { key: 'full_name', label: 'Full name' },
    { key: 'direction_code', label: 'Direction code' },
    { key: 'direction_name_uz', label: 'Direction' },
    { key: 'direction_is_priority', label: 'Priority direction' },
    { key: 'dc_type_name', label: 'Education type' },
    { key: 'course', label: 'Course' },
    { key: 'actions', label: 'Actions' },
  ]

  const organizationColumns = [
    { key: 'index', label: '#' },
    { key: 'organization_name', label: 'Organization' },
    { key: 'organization_inn', label: 'INN' },
    { key: 'is_sent', label: 'Status' },
    { key: 'items_count', label: 'Researchers count' },
    { key: 'approved_at', label: 'Approved at' },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    itemColumns,
    organizationColumns,
  }
}
